module.exports = __webpack_public_path__ + "img/bus_kamakura.b088cf07.jpg";